import { useHistory } from "react-router-dom";

import { Box, Button, Grid, Paper, Typography, useTheme } from "@mui/material";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";

import { hexToRgba } from "@aclymatepackages/converters";

const CleanupCalloutBanner = ({ rootPath }) => {
  const history = useHistory();
  const { palette } = useTheme();

  return (
    <Paper
      variant="outlined"
      style={{
        borderColor: palette.primary.main,
        backgroundColor: hexToRgba(palette.primary.main, 0.06)
      }}
    >
      <Box p={2}>
        <Grid container alignItems="center" spacing={2} wrap="nowrap">
          <Grid item>
            <Box
              p={1.5}
              style={{
                backgroundColor: hexToRgba(palette.primary.main, 0.15),
                borderRadius: 999,
                display: "flex"
              }}
            >
              <CleaningServicesIcon color="primary" />
            </Box>
          </Grid>
          <Grid item xs>
            <Typography variant="subtitle1">Vendor data cleanup</Typography>
            <Typography variant="body2" color="textSecondary">
              Review possible duplicate vendors, fix low-confidence industry
              classifications, and archive vendors with no transactions.
            </Typography>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                history.push(`${rootPath}/dashboard/vendors/cleanup`)
              }
            >
              Review →
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default CleanupCalloutBanner;
